import { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import type { Language } from "../../types/BookitupDocument";

const VatNote = ({ language }: { language?: Language }) => {
  const { profile } = useContext(ResourceContext);
  const { smallScaleBusiness, vatStatement, englishVatStatement } =
    profile ?? {};
  const statement = language === "english" ? englishVatStatement : vatStatement;

  if (smallScaleBusiness && statement) {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: statement }}
        style={{ marginBottom: 20 }}
      />
    );
  }
  return null;
};

export default VatNote;
